<template>
  <div class="west-drug-wrapper">
    <div class="west-drug" v-for="(drug, i) in drugList" :key="i">
      <div class="west-main">
        {{ drug.name }}
        {{ drug.spec }}
        【{{ drug.num }}{{ drug.unit }}】
      </div>
      <div class="west-sub">
        用法：{{ drug.usage }} 每次{{ drug.perNum }}{{ drug.perUnit }} {{ drug.usageFrequencyName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WestDrug',
  props: {
    drugList: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="scss">
.west-drug-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12pt;
  margin-bottom: 20pt;

  .west-drug {
    display: flex;
    flex-direction: column;
    gap: 2pt;

    .west-main {
      font-size: 12pt;
      font-weight: 500;
      color: #000;
      line-height: 1.4;
      word-break: break-all;
    }

    .west-sub {
      font-size: 10pt;
      font-weight: 400;
      color: #000;
      line-height: 1.4;
    }
  }
}
</style>
